import { createOptionsFrom } from "@/lib/common/Option";

export const ChartHistoryDurationDayLabels = {
	"7": "1 Week",
	"14": "2 Weeks",
	"31": "1 Month",
	"92": "3 Months",
	"183": "6 Months",
	"365": "1 Year",
	"730": "2 Years"
} as const;

export type ChartHistoryDuration = keyof typeof ChartHistoryDurationDayLabels;

export const ChartHistoryDurationOptions = createOptionsFrom(ChartHistoryDurationDayLabels);
